export type CampaignTarget = {
  country: string
  companyUuid: string
  name: string
  status: string
  ranges: number
}

export const campaignTargetFromServer = (x?: any): CampaignTarget =>
  x
    ? {
        country: x.country,
        companyUuid: x.company_uuid,
        name: x.name,
        status: x.status,
        ranges: x.ranges,
      }
    : { country: '', companyUuid: '', name: '', status: '', ranges: 0 }

// Build the campaign-targets list query (pagination + status/query filters).
export const getCampaignTargetsQuery = (meta: any) => ({
  limit: meta.rowsPerPage,
  offset: meta.page * meta.rowsPerPage,
  status: meta.filters?.status || undefined,
  query: meta.filters?.query || undefined,
})
